export default {"src":"/kelp/_next/static/media/kernel_app_logo.f552abaa.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};